var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23438 35.3062C5.10625 36.0469 3.52688 36.2156 2.185 35.7187C0.843125 35.2219 0 34.1625 0 33V2.99999C0 1.83749 0.855 0.778117 2.185 0.281242C3.515 -0.215633 5.09437 -0.0562579 6.23438 0.693742L29.0344 15.6937L30.4 16.5937V2.99999C30.4 1.34062 32.0981 -8.0457e-06 34.2 -8.0457e-06C36.3019 -8.0457e-06 38 1.34062 38 2.99999V33C38 34.6594 36.3019 36 34.2 36C32.0981 36 30.4 34.6594 30.4 33V19.4062L29.0344 20.3062L6.23438 35.3062Z",
    fill: "#7C6CC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/Next.058bb872578f6f460f027d5f1f0e772c.svg";
export { ForwardRef as ReactComponent };